const agreeCheck = document.getElementById('agreeCheck');

if (agreeCheck) {
  const goForm = document.getElementById('goForm');
  const goFormButton = goForm.querySelectorAll('button');
  agreeCheck.addEventListener('click', function () {
    //console.log(this.checked);
    if (this.checked) {
      goFormButton.forEach((button) => {
        button.disabled = false;
      });
    } else {
      goFormButton.forEach((button) => {
        button.disabled = true;
      });
    }
  });

  window.addEventListener('load', function () {
    agreeCheck.checked = false;
  });
}

//modal
if (document.querySelector('button[data-micromodal-trigger]')) {
  MicroModal.init({
    disableScroll: true,
    disableFocus: true,
  });
}
